import { render, staticRenderFns } from "./fbpClaimsDirectory.vue?vue&type=template&id=595bec92&scoped=true&lang=html"
import script from "./fbpClaimsDirectory.vue?vue&type=script&lang=js"
export * from "./fbpClaimsDirectory.vue?vue&type=script&lang=js"
import style0 from "./fbpClaimsDirectory.vue?vue&type=style&index=0&id=595bec92&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "595bec92",
  null
  
)

export default component.exports